const difficultyOrder = ['Easy', 'Medium', 'Hard'];

export const getUniqueTopics = (groups) => {
  return [...new Set(groups.map(group => group.topic))].sort((a, b) =>
    a.localeCompare(b)
  );
};

export const getDifficultyOptionsForTopic = (groups, topic) => {
  return groups
    .filter(group => group.topic === topic)
    .sort((a, b) => a.difficulty.localeCompare(b.difficulty))
    .map(group => ({
      groupId: group.id,
      difficulty: group.difficulty
    }));
};

export const getDefaultGroupIdForTopic = (groups, topic) => {
  return getDifficultyOptionsForTopic(groups, topic)[0]?.groupId || null;
};

export const getNextDifficultyGroupId = (groups, activeGroupId) => {
  const activeGroup = groups.find(group => group.id === activeGroupId);
  if (!activeGroup) return null;

  const topicGroups = groups
    .filter(group => group.topic === activeGroup.topic)
    .sort((a, b) => difficultyOrder.indexOf(a.difficulty) - difficultyOrder.indexOf(b.difficulty))
    .map(group => ({
      groupId: group.id,
      difficulty: group.difficulty
    }));
  const currentIndex = topicGroups.findIndex(group => group.groupId === activeGroupId);
  if (currentIndex === -1) return null;

  return topicGroups[currentIndex + 1]?.groupId || null;
};
